import cls from 'clsx';
import { useRef } from 'react';
import type { ReactNode } from 'react';
import { Transition } from 'react-transition-group';

import styles from './Fade.module.css';

// Matches `--ant-motion-duration-slow`, the length of the CSS transition
const DURATION = 300;

interface FadeProps {
  inProp?: boolean;
  className?: string;
  children?: ReactNode;
}

// Fades and slides its content in and collapses it when hidden
export const Fade = ({ inProp, className, children }: FadeProps) => {
  // Without a node ref the transition falls back to the deprecated findDOMNode
  const nodeRef = useRef<HTMLDivElement>(null);

  return (
    <Transition in={inProp} timeout={DURATION} nodeRef={nodeRef}>
      {(state) => (
        <div
          ref={nodeRef}
          className={cls(styles.fade, styles[state], className)}
        >
          {children}
        </div>
      )}
    </Transition>
  );
};
